import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Thermometer from "@/components/proposals/Thermometer";
import type { ProposalDetailsModalProps } from "@/features/Dashboard";
import {
  formatProposalDate,
  formatSeniorityDisplay,
} from "@/features/Dashboard";
import { MODAL_CLASSES } from "./proposalDetailsModal.definitions";

export default function ProposalDetailsModal({
  isOpen,
  proposal,
  onClose,
  getTypeName,
  getTechnologyName,
}: ProposalDetailsModalProps) {
  if (!proposal) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className={MODAL_CLASSES.panel}>
          <div className="p-6">
            <div className={MODAL_CLASSES.header}>
              <div>
                <Dialog.Title className={MODAL_CLASSES.title}>
                  {proposal.name}
                </Dialog.Title>
                <p className={MODAL_CLASSES.subtitle}>
                  ID do Cliente: {proposal.clientId}
                </p>
              </div>
              <button onClick={onClose} className={MODAL_CLASSES.closeButton}>
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>Gerente</h4>
                  <p className={MODAL_CLASSES.fieldValue}>{proposal.manager}</p>
                </div>
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>Status</h4>
                  <p className={MODAL_CLASSES.fieldValue}>{proposal.status}</p>
                </div>
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>Duração</h4>
                  <p className={MODAL_CLASSES.fieldValue}>
                    {proposal.duration}
                  </p>
                </div>
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>Data da Proposta</h4>
                  <p className={MODAL_CLASSES.fieldValue}>
                    {formatProposalDate(proposal.proposalDate)}
                  </p>
                </div>
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>
                    Fechamento Esperado
                  </h4>
                  <p className={MODAL_CLASSES.fieldValue}>
                    {formatProposalDate(proposal.expectedClosing)}
                  </p>
                </div>
                <div>
                  <h4 className={MODAL_CLASSES.fieldLabel}>Temperatura</h4>
                  <div className="mt-1">
                    <Thermometer
                      heatLevel={proposal.heatLevel}
                      mode="display"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h4 className={MODAL_CLASSES.sectionTitle}>
                  Recursos Necessários
                </h4>
                <div className="space-y-2">
                  {proposal.resources.map((resource, index) => (
                    <div key={index} className={MODAL_CLASSES.resourceCard}>
                      <div className="flex justify-between items-center">
                        <div>
                          <p className={MODAL_CLASSES.resourceType}>
                            {getTypeName(resource.typeId)}
                          </p>
                          <p className={MODAL_CLASSES.resourceDetails}>
                            {getTechnologyName(resource.technologyId)} -{" "}
                            {formatSeniorityDisplay(resource.seniority)}
                          </p>
                        </div>
                        <span className={MODAL_CLASSES.quantityBadge}>
                          {resource.quantity}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {proposal.notes && (
                <div>
                  <h4 className={MODAL_CLASSES.sectionTitle}>Observações</h4>
                  <p className={MODAL_CLASSES.notes}>{proposal.notes}</p>
                </div>
              )}
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
